import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';
import { generateUUID } from '@roc/feature-utils';
import { action, computed, makeObservable } from 'mobx';
import { FixFlipLoanEconomicsStore } from '../fixFlip/fixFlipLoanEconomicsStore';

const feeForm = ({ defaultName='', percentageAsDefault = false }) => ({
  fields: {
    name: {
      value: defaultName,
      error: null,
      rule: '',
    },
    usePercentage: {
      value: percentageAsDefault,
      error: null,
      rule: '',
    },
    capitalProviderPoints: {
      value: 0,
      error: null,
      rule: '',
    },
    capitalProviderAmount: {
      value: 0,
      error: null,
      rule: '',
    },
    lenderPoints: {
      value: 0,
      error: null,
      rule: '',
    },
    lenderAmount: {
      value: 0,
      error: null,
      rule: '',
    },
  },
  meta: {
    key: null,
    isValid: false,
    error: null,
  },
});

interface ILoanEconomicsStore {
  calculateFields: () => any;
}

export class FeeFormStore extends FormStore {
  private globalStore: GlobalStore;
  private loanEconomicsStore: ILoanEconomicsStore;

  public key = generateUUID();

  constructor(
    globalStore: GlobalStore,
    loanEconomicsStore: ILoanEconomicsStore,
    defaultName:string = '',
    percentageAsDefault: boolean = false
  ) {
    super(feeForm({ defaultName, percentageAsDefault }), globalStore);
    this.globalStore = globalStore;
    this.loanEconomicsStore = loanEconomicsStore;

    makeObservable(this, {
      toggleTypeOfValue: action,
      getFeeValues: action,
      isEmpty: computed,
    });
  }

  toggleTypeOfValue() {
    const calculatedFields = this.loanEconomicsStore.calculateFields();
    const values = this.getFeeValues(calculatedFields.totalLoanAmount);
    this.onFieldChange('usePercentage', !values.usePercentage);
    this.onFieldChange('lenderAmount', values.lenderAmount);
    this.onFieldChange('capitalProviderAmount', values.capitalProviderAmount);
    this.onFieldChange(
      'lenderPoints',
      parseFloat(values.lenderPoints.toFixed(2))
    );
    this.onFieldChange(
      'capitalProviderPoints',
      parseFloat(values.capitalProviderPoints.toFixed(2))
    );
  }

  getFeeValues(totalLoanAmount: number) {
    const values = this.getFormValues();
    const name = values.name;
    const usePercentage = values.usePercentage;

    let lenderAmount = values.lenderAmount || 0;
    let capitalProviderAmount = values.capitalProviderAmount || 0;
    let lenderPoints = values.lenderPoints || 0;
    let capitalProviderPoints = values.capitalProviderPoints || 0;

    if (usePercentage) {
      lenderAmount = (lenderPoints / 100) * totalLoanAmount;
      capitalProviderAmount = (capitalProviderPoints / 100) * totalLoanAmount;
    } else {
      lenderPoints = (lenderAmount / totalLoanAmount) * 100;
      capitalProviderPoints = (capitalProviderAmount / totalLoanAmount) * 100;
    }

    return {
      name,
      usePercentage,
      lenderAmount,
      capitalProviderAmount,
      lenderPoints,
      capitalProviderPoints,
    };
  }

  get isEmpty() {
    const values = this.getFormValues();
    return !values.name;
  }
}
